import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import UserAuth from "./components/UserAuth/UserAuth";
import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import { ToastProvider } from "./contexts/ToastContext";
import { UserProvider } from "./contexts/UserContext";
import Contact from "./pages/Contact";
import CreateEventPage from "./pages/CreateEventPage";
import ErrorPage from "./pages/ErrorPage";
import EventPhotosGuest from "./pages/EventPhotosGuest";
import EventsDashboard from "./pages/EventsDashboard";
import EventView from "./pages/EventView";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ProfilePage from "./pages/ProfilePage";
import TermsOfService from "./pages/TermsOfService";

import "./styles/globals.css";
import "./styles/redesign.css";

// Loading component for translations
const AppWithTranslations = () => {
  const { isLoading } = useLanguage();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/auth" element={<UserAuth />} />
        <Route path="/event/:eventId" element={<EventView />} />
        <Route path="/event/:eventId/photos" element={<EventPhotosGuest />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route
          path="/create-event"
          element={
            <ProtectedRoute>
              <CreateEventPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/events/dashboard"
          element={
            <ProtectedRoute>
              <EventsDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        {/* Catch-all route for 404 errors */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </div>
  );
};

function App() {
  const paypalOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID || "test",
    currency: "USD",
    intent: "capture",
    components: "buttons",
    "disable-funding":
      "credit,card,sepa,bancontact,eps,giropay,ideal,mybank,p24,sofort,venmo",
  };

  return (
    <LanguageProvider>
      <ErrorBoundary>
        <Router>
          <ToastProvider>
            <UserProvider>
              <PayPalScriptProvider options={paypalOptions}>
                <AppWithTranslations />
              </PayPalScriptProvider>
            </UserProvider>
          </ToastProvider>
        </Router>
      </ErrorBoundary>
    </LanguageProvider>
  );
}

export default App;
